import React from "react";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";

const ForgotPassword = () => {
  const { userData, updateUserData, userEmailVerify } = useGlobal();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await userEmailVerify();
  };
  return (
    <section className="login-section-bg">
      <div className="container-main d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-center">
          <div className="auth-logo">
            <img
              src={images.pureTouchLogo}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mb-5">
          <h5 className="mb-4 text-center text-primary fw-semibold ">
            Forgot Password
          </h5>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="">
              <label className="form-label">
                Email
                {!userData.email && <span className="text-danger"> *</span>}
              </label>
              <input
                type="email"
                value={userData.email}
                onChange={(e) => updateUserData("email", e.target.value)}
                className="form-control input-tags"
                placeholder="Enter email / mobile number"
              />
            </div>

            <div className="mt-3 text-center">
              <button type="submit" className="btn btn-primary mt-2">
                Send Email
              </button>
            </div>

            <div className="mt-4 text-center">
              <span className="text-muted fs-14">I remember my password? </span>
              <span
                className="text-primary cursor-pointer text-decoration-underline fw-semibold fs-14"
                onClick={() => navigate("/login")}
              >
                Sign In here
              </span>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
